import { useHooks } from './useHooks';
import {
  getSiteTaskHistory,
  getSiteTaskHistoryDiff
} from '../../../../apicalls/taskHistory';

import { HistoryModal } from '../../common/HistoryModal';
import { Dispatch, FC } from 'react';
import { SITE_TASK_ITEM_LIST } from '../../../../const/TaskConst';

export type TProps = {
  constructId: number;
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
};

export const SiteTaskHistoryModal: FC<TProps> = props => {
  const { constructId, isOpen, setIsOpen } = props;
  const { createHistoryDataText, createHistoryDiffDataList } = useHooks();

  return (
    <HistoryModal
      id={constructId}
      apiHistory={getSiteTaskHistory}
      createHistoryText={createHistoryDataText}
      apiHistoryDiff={getSiteTaskHistoryDiff}
      createHistoryDiffList={createHistoryDiffDataList}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'更新履歴'}
      itemList={SITE_TASK_ITEM_LIST}
    />
  );
};
